export default {
	id: 'SIMPLE_PREMIUM_FALLBACK_1M_39_1M_7_99',
	providers: {
		paltaMap: {
			USD: 'simple_premium_1m_39_1m_7_99_usd',
			EUR: 'simple_premium_1m_39_1m_7_99_eur',
			GBP: 'simple_premium_1m_39_1m_7_99_gbp',
			AUD: 'simple_premium_1m_73_1m_11_99_aud',
			CAD: 'simple_premium_1m_73_1m_11_99_cad',
			DKK: 'simple_premium_1m_379_1m_55_2_dkk',
			SEK: 'simple_premium_1m_585_1m_88_sek',
			NOK: 'simple_premium_1m_585_1m_88_nok',
			BRL: 'simple_premium_1m_99_1m_20_79_brl',
			MXN: 'simple_premium_1m_649_1m_135_2_mxn',
			TRY: 'simple_premium_1m_1499_1m_266_4_try',
			ARS: 'simple_premium_1m_51990_1m_10392_ars',
			COP: 'simple_premium_1m_157990_1m_31992_cop',
			CLP: 'simple_premium_1m_37990_1m_7992_clp',
		},
		primer: 'prd_tF4Nb2CJh5bQ',
	},
}
